/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/sparkline.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * The values representing the y-axis values of a sparkline graph for a given aggregation over a period of time.
 *
 * @example
 * FROM employees
 * | STATS sparkline = SPARKLINE(COUNT(*), hire_date, 20, "1985-01-01T00:00:00Z", "1985-12-31T00:00:00Z")
 */
const definition: FunctionDefinition = {
  type: 'agg',
  name: 'sparkline',
  signatures: [
    {
      params: [
        {
          name: 'aggregation',
          type: 'double',
          optional: false,
          hint: {
            kind: 'aggregation',
          },
        },
        {
          name: 'key',
          type: 'date',
          optional: false,
        },
        {
          name: 'buckets',
          type: 'integer',
          optional: false,
        },
        {
          name: 'from',
          type: 'text',
          optional: false,
        },
        {
          name: 'to',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'aggregation',
          type: 'integer',
          optional: false,
          hint: {
            kind: 'aggregation',
          },
        },
        {
          name: 'key',
          type: 'date',
          optional: false,
        },
        {
          name: 'buckets',
          type: 'integer',
          optional: false,
        },
        {
          name: 'from',
          type: 'date',
          optional: false,
        },
        {
          name: 'to',
          type: 'date',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'integer',
    },
    {
      params: [
        {
          name: 'aggregation',
          type: 'long',
          optional: false,
          hint: {
            kind: 'aggregation',
          },
        },
        {
          name: 'key',
          type: 'date',
          optional: false,
        },
        {
          name: 'buckets',
          type: 'integer',
          optional: false,
        },
        {
          name: 'from',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'to',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'long',
    },
  ],
  preview: true,
  snapshotOnly: false,
  tsdbCompatible: false,
};

export default definition;
